// Angular
import { NgModule } from '@angular/core';

// Afidium
import { ApiResourceModule } from 'libraries/service/apiResource/apiResource.module';
import { ProcessingSmsResourceService } from './processing-sms-resource.service';


@NgModule({
    imports: [
        ApiResourceModule
    ],
    providers: [
        ProcessingSmsResourceService,
    ]
})
export class ProcessingSmsResourceModule {  }